import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { hero } from "../../../assets/images";

const Hero = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 500);
    const buttonTimer = setTimeout(() => setShowButton(true), 1600);
    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, []);

  return (
    <div className="relative w-full h-[500px] md:h-[564px] overflow-hidden">
      {/* Background Image */}
      <img
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        src={hero}
        alt="Hero Background"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />

      {/* Content */}
      <div className="absolute inset-0 flex items-center z-20 max-w-containerSm md:max-w-container mx-auto">
        <div className="md:w-[476px] ">
          <div className="text-white">
            <p
              className={`text-[white] text-[36px] font-bold font-firstFont md:text-[64px] transition-all duration-1000 ease-out transform ${
                showText
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
            >
              {t("Thin minds - bold solutions")}
            </p>
          </div>

          <div>
            <p
              className={`text-[#EBECEE] text-[14px] md:text-[16px] transition-all duration-1000 ease-out delay-500 transform ${
                showText
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
            >
              {t(
                "We deliver powerful solutions through cutting-edge technology, empowering industries to move forward"
              )}
            </p>

            <a href={`/${currentLanguage}/contact`}>
              <div
                className={`group flex items-center px-6 justify-center h-[44px] w-full md:w-[200px] bg-[#B31F11] text-[white] rounded-[6px] mt-[130px] md:mt-10 transition-all duration-1000 ease-out delay-700 transform ${
                  showButton
                    ? "opacity-100 translate-x-0"
                    : "opacity-0 -translate-x-10"
                }`}
              >
                <p className="font-medium py-3 group-hover:scale-105 transition-transform duration-300">
                  {t("Get a Quote")}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
